<template lang="html">
  <v-flex pa-0>
    <v-flex
      v-if="section.textPre"
      xs12
      v-html="_templateLiteralString(section.textPre)"
    />
    <!-- <v-flex xs12 v-if="section.textPre" v-html="section.textPre"></v-flex> -->

    <v-simple-table class="si-plain-table align-rows-top">
      <tbody v-if="valuationFormula.length > 0">
        <tr
          v-for="(formula, i) in valuationFormula"
          :key="`valuation_formula_${i}`"
        >
          <td
            class="pr-0 py-2 px-1 pr-2 si-formula-label"
            v-html="formula.label"
          />
          <td class="pl-0 py-2 px-1">
            <v-layout
              v-if="formula.formula"
              ma-0
            >
              <v-flex
                shrink
                py-0
                px-1
              >
                =
              </v-flex><v-flex
                class="no-break"
                shrink
                py-0
                px-1
                v-html="formula.formula"
              />
            </v-layout>
            <v-layout
              v-if="formula.working"
              ma-0
            >
              <v-flex
                shrink
                py-0
                px-1
              >
                =
              </v-flex><v-flex
                class="no-break"
                shrink
                py-0
                px-1
                v-html="formula.working"
              />
            </v-layout>
            <v-layout
              v-if="formula.result"
              ma-0
            >
              <v-flex
                shrink
                py-0
                px-1
              >
                =
              </v-flex><v-flex
                class="no-break"
                shrink
                py-0
                px-1
                v-html="formula.result"
              />
            </v-layout>
            <div
              v-if="formula.factors"
              class="mt-4 si-stop-children-breaking"
            >
              <div class="caption font-italic">
                Where:
              </div>
              <v-divider />
              <tbody>
                <tr
                  v-for="(fac, i) in formula.factors"
                  :key="`formula_factors_${i}`"
                  style="font-size: 90%;"
                >
                  <td
                    class="pr-0 py-2 px-1 pr-3  si-sub-formula-label"
                    v-html="fac.label"
                  />
                  <td class="pl-0 py-2 px-1">
                    <v-layout
                      v-if="fac.formula"
                      ma-0
                    >
                      <v-flex
                        shrink
                        py-0
                        px-1
                      >
                        =
                      </v-flex><v-flex
                        class="no-break"
                        shrink
                        py-0
                        px-1
                        v-html="fac.formula"
                      />
                    </v-layout>
                    <v-layout
                      v-if="fac.working"
                      ma-0
                    >
                      <v-flex
                        shrink
                        py-0
                        px-1
                      >
                        =
                      </v-flex><v-flex
                        class="no-break"
                        shrink
                        py-0
                        px-1
                        v-html="fac.working"
                      />
                    </v-layout>
                    <v-layout
                      v-if="fac.result"
                      ma-0
                    >
                      <v-flex
                        shrink
                        py-0
                        px-1
                      >
                        =
                      </v-flex><v-flex
                        class="no-break"
                        shrink
                        py-0
                        px-1
                        v-html="fac.result"
                      />
                    </v-layout>
                  </td>
                </tr>
              </tbody>
            </div>
          </td>
        </tr>
      </tbody>
      <tbody v-else>
        <tr>
          <td
            class="pr-0 py-2 px-1"
            v-html="formula.label"
          />
          <td class="pl-0 py-2 px-1">
            <v-layout
              v-if="formula.formula"
              ma-0
            >
              <v-flex
                shrink
                py-0
                px-1
              >
                =
              </v-flex><v-flex
                class="no-break"
                shrink
                py-0
                px-1
                v-html="formula.formula"
              />
            </v-layout>
            <v-layout
              v-if="formula.working"
              ma-0
            >
              <v-flex
                shrink
                py-0
                px-1
              >
                =
              </v-flex><v-flex
                class="no-break"
                shrink
                py-0
                px-1
                v-html="formula.working"
              />
            </v-layout>
            <v-layout
              v-if="formula.result"
              ma-0
            >
              <v-flex
                shrink
                py-0
                px-1
              >
                =
              </v-flex><v-flex
                class="no-break"
                shrink
                py-0
                px-1
                v-html="formula.result"
              />
            </v-layout>
          </td>
        </tr>
        <tr
          v-for="(factor, i) in factors"
          :key="i"
          style="font-size: 90%;"
        >
          <td
            class="pr-0 py-2 px-1 pr-3  si-sub-formula-label"
            v-html="factor.label"
          />
          <td class="pl-0 py-2 px-1">
            <v-layout
              v-if="factor.formula"
              ma-0
            >
              <v-flex
                shrink
                py-0
                px-1
              >
                =
              </v-flex><v-flex
                class="no-break"
                shrink
                py-0
                px-1
                v-html="factor.formula"
              />
            </v-layout>
            <v-layout
              v-if="factor.working"
              ma-0
            >
              <v-flex
                shrink
                py-0
                px-1
              >
                =
              </v-flex><v-flex
                class="no-break"
                shrink
                py-0
                px-1
                v-html="factor.working"
              />
            </v-layout>
            <v-layout
              v-if="factor.result"
              ma-0
            >
              <v-flex
                shrink
                py-0
                px-1
              >
                =
              </v-flex><v-flex
                class="no-break"
                shrink
                py-0
                px-1
                v-html="factor.result"
              />
            </v-layout>
          </td>
        </tr>
      </tbody>
    </v-simple-table>

    <!-- <v-flex xs12 v-if="section.textPost" v-html="_templateLiteralString(section.textPost)"></v-flex> -->
    <v-flex
      v-if="section.textPost"
      xs12
      v-html="section.textPost"
    />
  </v-flex>
</template>

<script>
import helpers from '@/mixins/helpers'
export default {
  mixins: [ helpers ],
  props: {
    data: Object,
    section: Object
  },
  computed: {
    report () {
      return this.data.report || {}
    },
    formula () {
      return this.report.formula || {}
    },
    factors () {
      return this.report.factors || []
    },
    valuationFormula () {
      return (this.report.valuation || {}).formula || []
    },
    schemeFormula () {
      return (this.report.scheme || {}).formula || []
    }
  }
}
</script>

<style lang="css" >
.si-formula-label {
    width: 33%;
  }
@media screen and (min-width: 800px) {
  .si-formula-label {
    white-space: nowrap;
    width: 10px;
  }
  .si-sub-formula-label {
    white-space: nowrap;
    width: 10px;
  }
}
@media print {
  .si-formula-label {
    white-space: nowrap;
    width: 10px;
  }
  .si-sub-formula-label {
    white-space: nowrap;
    width: 10px;
  }

  
}
</style>
